import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import DevicesComponent from './Devices.component';
import useUserInfo from '../Hooks/useUserInfo';
import HubDetails from '../HubDetails/HubDetails';
import AddAccount from './AddAccount';
import { getProfilePicUrl } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { Actions, PhotoResolution } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { getProfilePics, getUserHubs } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { useLocation } from 'react-router-dom';
import useGetInventoryDevices from '../Hooks/useGetInventoryDevices';

const Devices = () => {
  const location = useLocation();
  const deviceCount = location.state?.count || 1000;
  const currentUser = useSelector(getCurrentUser);
  const { useruuid, providerid: providerId } = useMemo(() => currentUser, [currentUser]);
  useUserInfo({ useruuid });

  const showPagination = deviceCount > 1000; // change here to show pagination
  const [limit, setLimit] = useState(showPagination ? 10 : deviceCount);
  const [offset, setOffset] = useState(0);

  const [action, setAction] = useState(null);
  const [record, setRecord] = useState(null);
  const [queryParams, setQueryParams] = useState({
    filterkey: 'category',
    filtervalue: 'DEVICE-PRIMARY',
    sortby: 'deviceid',
    orderby: 'asc',
  });
  const navigationKey = true;

  const userHubs = useSelector(getUserHubs(useruuid));
  const resourceMap = useSelector(getProfilePics());
  const userData = useSelector((user) => user.data.userInfo);
  const updatedUserInfo = userData[useruuid];
  const mUserHubs = useMemo(() => {
    return userHubs.map((hub) => ({
      ...hub,
      profilePic64: getProfilePicUrl(hub.useruuid, resourceMap, PhotoResolution.R64),
    }));
  }, [userHubs]);

  const {
    data: inventoryDevices = [],
    isFetching: fetchingDeviceData,
    refetch: fetchDevices,
  } = useGetInventoryDevices({ useruuid, queryParams, providerId, offset, limit });

  /* handler functions */
  const onActionClick = (action, record, offset, limit) => () => {
    let resolvedRecord = record;
    if (action === Actions.listHub && record?.deviceuuid) {
      const matchedHub = mUserHubs.find((hub) => hub.deviceuuid === record.deviceuuid);
      if (matchedHub) {
        resolvedRecord = matchedHub;
      }
    }
    setAction(action);
    setRecord(resolvedRecord);
    setOffset(offset);
    setLimit(limit);
    fetchDevices();
  };

  const onSubmit = ({ update = true, redirect = true } = {}) => {
    update && fetchDevices();
    redirect && setAction(null);
    redirect && setRecord(null);
  };

  return !action ? (
    <DevicesComponent
      providerId={providerId}
      fetchDevices={fetchDevices}
      deviceData={inventoryDevices}
      fetchingDeviceData={fetchingDeviceData}
      onActionClick={onActionClick}
      // onSubmit={onSubmit}
      deviceCount={deviceCount}
      showPagination={showPagination}
      offset={offset}
      limit={limit}
      userHubsData={mUserHubs}
      setQueryParams={setQueryParams}
    />
  ) : action === Actions.listHub ? (
    <HubDetails
      onActionClick={onActionClick}
      hubRecord={record}
      userHubsData={mUserHubs}
      offset={offset}
      limit={limit}
      openSubMenu={true}
      navigationKey={navigationKey}
      sendMsgDisplay={true}
      showContactingStaff={true}
      fetchDevices={fetchDevices}
      deviceData={inventoryDevices}
      fetchingDeviceData={fetchingDeviceData}
      showPagination={showPagination}
      loginUserTimeformat={{ is24hoursformat: updatedUserInfo?.is24hoursformat }}
      loginUserMeasurementUnit={{ measurement: updatedUserInfo?.measurement }}
    />
  ) : action === Actions.assignDevice ? (
    <AddAccount onActionClick={onActionClick} deviceRecord={record} offset={offset} limit={limit} />
  ) : (
    <></>
  );
};

Devices.propTypes = {};

export default Devices;
